module.exports = __webpack_public_path__ + "static/img/gffgtk@2x.bad9c95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/gffgtk@2x.png
// module id = aTRt
// module chunks = 1